/* Moves the footer's app-block slot (e.g. an EU right-of-withdrawal button)
   from its rendered position after the link columns into the last column's
   own box, directly under its links.

   A DOM move, not real nesting: link_column is a local (inline-schema)
   block, and neither `render block` nor `content_for 'block', type:, id:`
   actually renders a nested app block for one — verified directly against
   the dev store, see the comments in hystride-footer.liquid. CSS can't
   place .ft-app under a specific column's own content either, since a
   shared grid/flex row always sizes to its tallest sibling (Shop's longer
   link list), not the shorter Hystride column next to it. Moving the
   already-correctly-rendered element after the fact sidesteps both limits.
*/
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('footer', {
    mount(root) {
      const cols = root.querySelector('.ft-cols');
      const app = root.querySelector('.ft-app');
      if (!cols || !app) return null;

      const columns = Array.from(cols.children).filter((el) => el !== app);
      const last = columns[columns.length - 1];
      if (last) last.appendChild(app);

      return null;
    },
  });
})();
